import { fetchMerchandisingApi } from "app/pages/Merchandising/merchandisingActionCreators";

const rejectWithResponse = error => Promise.reject(error.response || error);

// useQuery refuse `undefined` comme donnée : un merch absent de la réponse devient `null`.
export const fetchHeroCommercialMerchandising = params =>
	fetchMerchandisingApi(params).then(
		response => response.data?.merchandising ?? null,
		rejectWithResponse
	);
